import { TimezoneWrapper } from '@core/models/timezone-wrapper';
import { createAction, props } from '@ngrx/store';

export const LoadTimezonesProps = createAction(
  '[Timezones] Load Timezones Props'
);

export const LoadTimezonesProperties = createAction(
  '[Timezones] Load Timezones Success',
  props<{ timezonesProperties: TimezoneWrapper[] }>()
);

export const SetSenderTimezone = createAction(
  '[SetSenderTimezone] Action',
  props<{ senderTimezone: {} }>()
);

export const SetRecipientTimezone = createAction(
  '[SetRecipientTimezone] Action',
  props<{ recipientTimezone: {} }>()
);
